import React from "react";
import { Hero } from "@/components/home/Hero";
import { FeaturedCollections } from "@/components/home/FeaturedCollections";
import { BestSellers } from "@/components/home/BestSellers";
import { PromoBanner } from "@/components/home/PromoBanner";
import { NewArrivals } from "@/components/home/NewArrivals";
import { WhyChooseUs } from "@/components/home/WhyChooseUs";
import { ReviewsCarousel } from "@/components/home/ReviewsCarousel";
import { InstagramSection } from "@/components/home/InstagramSection";
import { NewsletterSection } from "@/components/home/NewsletterSection";
import { QuickViewModal } from "@/components/product/QuickViewModal";
import { SEO } from "@/components/common/SEO";
import { brand } from "@/config/brand";

export default function HomePage() {
  const [quick, setQuick] = React.useState(null);

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "Store",
    name: brand.name,
    description: brand.tagline,
    currenciesAccepted: "INR",
  };

  return (
    <>
      <SEO
        description="Discover timeless handcrafted jewellery at ÉLORA — necklaces, earrings, rings, bracelets and bridal sets designed to make every moment shine."
        jsonLd={jsonLd}
      />
      <Hero />
      <FeaturedCollections />
      <BestSellers onQuickView={setQuick} />
      <PromoBanner />
      <NewArrivals onQuickView={setQuick} />
      <WhyChooseUs />
      <ReviewsCarousel />
      <InstagramSection />
      <NewsletterSection />
      <QuickViewModal product={quick} open={!!quick} onOpenChange={(o) => !o && setQuick(null)} />
    </>
  );
}
